import React from 'react';
import {connect} from 'react-redux';
import BasicButton from 'Components/common/BasicButton';
import BasicTextArea from 'Components/common/BasicTextArea';
import SelectInput from 'Components/common/SelectInput';
import {openNotification} from 'Actions/notification';
import {T} from 'Actions/translate';

class ProxyDeliveryReject extends React.Component {
    state = {
        reason: '',
        remark: '',
        selectedReason: null,
    };

    codeCountdownTimer = null;

    handleReasonChange = (name, value) => {
        if (value && typeof value === 'object') {
            const displayLabel =
                value.fullName ||
                value.name ||
                value.label ||
                value.value ||
                '';
            this.setState({
                reason: displayLabel,
                selectedReason: value,
            });
        } else {
            this.setState({
                reason: value || '',
                selectedReason: null,
            });
        }
    };

    handleTextArea = (title, value) => {
        this.setState({remark: value || ''});
    };

    clearTextArea = () => {
        this.setState({remark: ''});
    };

    isRemarkRequired = () => {
        const {reason, selectedReason} = this.state;
        const candidates = [];

        if (selectedReason && typeof selectedReason === 'object') {
            const {fullName, name, label, value, key, id, original} =
                selectedReason;

            candidates.push(fullName, name, label, value, key, id);

            if (original && typeof original === 'object') {
                candidates.push(
                    original.fullName,
                    original.name,
                    original.label,
                    original.value,
                    original.key,
                    original.dictLabel,
                    original.dictValue,
                    original.code,
                );
            }
        }

        candidates.push(reason);

        return candidates.some((item) => {
            if (!item || typeof item !== 'string') {
                return false;
            }

            const normalized = item.trim().toLowerCase();

            if (!normalized) {
                return false;
            }

            if (
                normalized === '其他' ||
                normalized === '其它' ||
                normalized === '其他原因' ||
                normalized === '其它原因'
            ) {
                return true;
            }

            return normalized.includes('other');
        });
    };

    handleRejectHandle = () => {
        const {onReject, openNotification} = this.props;
        const {selectedReason, reason, remark} = this.state;
        const remarkRequired = this.isRemarkRequired();

        if (typeof onReject !== 'function') {
            return;
        }

        const reasonValue = selectedReason
            ? selectedReason.value ||
              selectedReason.key ||
              selectedReason.id ||
              selectedReason.name ||
              selectedReason.fullName
            : reason;
        const reasonLabel = selectedReason
            ? selectedReason.fullName ||
              selectedReason.name ||
              selectedReason.label ||
              selectedReason.value ||
              selectedReason.key
            : reason;

        const normalizedReasonValue =
            typeof reasonValue === 'string' ? reasonValue.trim() : reasonValue;
        const normalizedReasonLabel =
            typeof reasonLabel === 'string' ? reasonLabel.trim() : reasonLabel;
        const hasReasonValue =
            normalizedReasonValue !== undefined &&
            normalizedReasonValue !== null &&
            (typeof normalizedReasonValue === 'string'
                ? normalizedReasonValue !== ''
                : true);
        const hasReasonLabel =
            normalizedReasonLabel !== undefined &&
            normalizedReasonLabel !== null &&
            (typeof normalizedReasonLabel === 'string'
                ? normalizedReasonLabel !== ''
                : true);

        const trimmedRemark = (remark || '').trim();

        if (!hasReasonValue && !hasReasonLabel) {
            if (typeof openNotification === 'function') {
                openNotification(
                    T('proxy_delivery_reject_reason_required'),
                    'danger',
                );
            }
            return;
        }

        if (remarkRequired && !trimmedRemark) {
            if (typeof openNotification === 'function') {
                openNotification(
                    T('proxy_delivery_reject_remark_required'),
                    'danger',
                );
            }
            return;
        }

        onReject({
            reason: hasReasonValue
                ? normalizedReasonValue
                : hasReasonLabel
                ? normalizedReasonLabel
                : '',
            remark: trimmedRemark,
        });
    };

    handleCancel = () => {
        const {onClose} = this.props;

        this.setState({reason: '', remark: '', selectedReason: null}, () => {
            if (typeof onClose === 'function') {
                onClose();
            }
        });
    };

    focusInput = () => {};
    render() {
        const {uploadFileBtnIsLoading, rejectReasonOptions = []} = this.props;
        const {reason, remark} = this.state;
        const remarkRequired = this.isRemarkRequired();
        return (
            <div className="proxy-delivery-reject-dialog">
                <div className="signature-method-section">
                    <h5 className="upload-method-title text-center">
                        {T('proxy_delivery_reject_package')}
                    </h5>
                </div>
                <div>
                    <SelectInput
                        title={'proxy_delivery_reject_reason'}
                        placeholder={''}
                        list={rejectReasonOptions}
                        value={reason}
                        inputValid={this.handleReasonChange}
                        type="text"
                        required
                        focusInput={() => {
                            this.focusInput();
                        }}
                    />
                    <BasicTextArea
                        type="text"
                        title={'proxy_delivery_reject_remark'}
                        placeholder={''}
                        inputValid={this.handleTextArea}
                        clearInput={this.clearTextArea}
                        maxlength={200}
                        defalutValue=""
                        value={remark}
                        required={remarkRequired}
                    />
                </div>
                <div className="upload-method-actions">
                    <BasicButton
                        type="primary"
                        className="upload-method-submit"
                        loading={uploadFileBtnIsLoading}
                        onClickOfSingleTap={this.handleRejectHandle}>
                        <span>{T('proxy_delivery_confirm_reject')}</span>
                    </BasicButton>
                    <BasicButton
                        type="default"
                        className="upload-method-cancel"
                        onClickOfSingleTap={this.handleCancel}>
                        <span>{T('cancel')}</span>
                    </BasicButton>
                </div>
            </div>
        );
    }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {openNotification})(
    ProxyDeliveryReject,
);
